module.exports = __webpack_public_path__ + "img/Mushroom.e52b85ef.png";